__turbopack_context__.v({
  "content": "_5l25BG_content",
  "image": "_5l25BG_image",
  "img-container": "_5l25BG_img-container",
  "items-container": "_5l25BG_items-container",
  "related-element": "_5l25BG_related-element",
  "root": "_5l25BG_root",
  "text": "_5l25BG_text",
});
